import { useGetImgixImageUrl } from '../../../../../../../hooks';
import { PropsWithTestId } from '../../../../../../../types';
import cn from 'classnames';

import styles from './Image.module.scss';
import { useImageWithFallback } from './hooks/useImageWithFallback';

export enum ImageStyles {
  default = 'default',
  list = 'list',
  smallList = 'smallList',
}

export interface ImageProps {
  path: string;
  imageStyle: keyof typeof ImageStyles;
  fallback?: string;
  className?: string;
}

export function Image(props: PropsWithTestId<ImageProps>) {
  const { path, imageStyle, testId, className, fallback } = props;
  const image = useGetImgixImageUrl(path);

  const imageUrl = useImageWithFallback(image, fallback);

  return (
    <div className={cn(styles.wrapper, className)}>
      <div
        className={cn(styles.image, styles[imageStyle])}
        style={{ backgroundImage: imageUrl ? `url('${imageUrl}')` : 'none' }}
        data-testid={testId}
      />
    </div>
  );
}

Image.defaultProps = {
  imageStyle: ImageStyles.default,
  testId: 'card-image',
};
